interface IAccountNumberProps {
  value: string
}

const AccountNumber = (props: IAccountNumberProps) => {
  const value = props.value
  let number = value

  if (value) {
    if (value.length === 24) {
      // length = 24
      number =
        value.substring(0, 8) +
        "-" +
        value.substring(8, 16) +
        "-" +
        value.substring(16, 24)
    } else if (value.length === 16) {
      // length = 16
      number = value.substring(0, 8) + "-" + value.substring(8, 16)
    }
  }

  return <>{number}</>
}

export default AccountNumber
